import SvgIcon from "@/components/common/SvgIcon";
import { Button, Typography } from "@/components/kit";
import { copyText } from "@/utilize/CopyText";
import { IUser } from "../types";
import moment from "moment";
import { useFormikContext } from "formik";

const KeyHighlights = ({ user }: { user: IUser | undefined | null }) => {
  const { setFieldValue, values } = useFormikContext<IUser>();
  if (!user) return null;
  return (
    <div className="w-[315px] border border-gray-100  rounded-xl bg-gray-50 ">
      <div className="bg-gray-100 px-6 py-[18px]">
        <div className="flex items-center gap-[9px]">
          <SvgIcon
            width={24}
            height={24}
            className="w-6 h-6"
            fill="fill-[#B2BEC3]"
            iconName="lightbulb"
          />
          <Typography variant="Title5-Regular">Key Highlights</Typography>
        </div>
      </div>
      <div className="px-6 py-4">
        <div className="flex w-full justify-between pb-3 border-b border-gray-100">
          <div className="flex flex-col gap-2 w-full ">
            <Typography variant="Caption1-Regular" className="!text-gray-400">
              Work email
            </Typography>
            <div className="flex items-center w-full justify-between min-w-0 ">
              <Typography
                hasTitle
                variant="Body2-Regular"
                className="!text-gray-700 truncate flex-1 pr-2"
              >
                {user.email}
              </Typography>
              <SvgIcon
                onClick={() => copyText(user.email)}
                iconName="copy"
                className="cursor-pointer"
                fill="fill-blue-700"
              />
            </div>
          </div>
        </div>

        <div className="flex w-full  py-3 border-b border-gray-100">
          <div className="flex flex-col gap-2 w-full ">
            <Typography variant="Caption1-Regular" className="!text-gray-400">
              Display name{" "}
            </Typography>
            <div className="flex items-center w-full justify-between ">
              <Typography
                hasTitle
                variant="Body2-Regular"
                className="!text-gray-700"
              >
                {user.displayName}
              </Typography>
            </div>
          </div>
        </div>
        <div className="flex w-full  py-3 border-b border-gray-100">
          <div className="flex flex-col gap-2 w-full ">
            <Typography variant="Caption1-Regular" className="!text-gray-400">
              Last login{" "}
            </Typography>
            <div className="flex items-center w-full justify-between ">
              <Typography
                hasTitle
                variant="Body2-Regular"
                className="!text-gray-700"
              >
                {user.lastLogin
                  ? moment(user.lastLogin).format("MMM D, YYYY")
                  : "-"}
              </Typography>
            </div>
          </div>
        </div>
        <div className="flex w-full  py-3 border-b border-gray-100">
          <div className="flex flex-col gap-2 w-full ">
            <Typography variant="Caption1-Regular" className="!text-gray-400">
              Multi-Factor Authentication
            </Typography>
            <div className="flex w-full flex-col ">
              <Typography
                hasTitle
                variant="Body2-Regular"
                className="!text-gray-700"
              >
                {values.mfaEnforced
                  ? "MFA is enabled"
                  : "MFA is not activated yet."}
              </Typography>
              <div className="flex w-full justify-end mt-3">
                {!values.mfaEnforced && (
                  <Button
                    onClick={() => setFieldValue("mfaEnforced", true)}
                    variant="text"
                    className="bg-gradient-to-b rounded-xl from-[#4991F7] to-[#357CF5] text-white"
                  >
                    Activate your MFA{" "}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyHighlights;
